export default {
    current_choice: 'Dabartinis pasirinkimas',
    book_now: 'Užsakyti dabar',
    minimum_age: 'Tik nuo {age} metų',
    excess_liability: 'Papildoma atsakomybė',
    security_deposit: 'Užstatas',
    fuel_policy: 'Degalų politika',
    like_for_like: 'Toks pats už tokį patį',
    full_to_full: 'Pilnas iki pilno',
    miles_per_rental: '{mileage} nemokamų mylių nuomai',
    km_per_rental: '{mileage} nemokamų km nuomai',
    unlimited_mileage: 'Neribotas nuvažiuotas atstumas',
    unlimited_mileage_km: 'Neriboti km',
    non_amendable: 'Negalima keisti',
    non_refundable: 'Negrąžinama',
    free_cancellation_until: 'Nemokamas atšaukimas iki',
    basic_free_cancellation: 'Nemokamas atšaukimas likus ne mažiau kaip 48 valandoms iki pradžios',
    cancellation_in_line_with: 'Atšaukimas pagal',
    tcs: 'Taisyklės ir sąlygos',
    free_extras_on_collection: 'Du nemokami priedai atsiėmimo metu',
    glass_and_tyres_covered: 'Stiklai ir padangos apdrausti',
    number_of_passengers: 'Keleivių skaičius',
    number_of_bags: 'Bagažo kiekis',
    fuel_type: 'Degalų tipas',
    co2: 'CO2',
    aircon: 'Oro kondicionierius',
    transmission: 'Pavarų dėžė',
    book_type: 'Užsakyti {type}',
    debit_card_deposit: 'Priimamos debeto kortelės užstatui',
    fast_track_included: 'Greitas aptarnavimas įtrauktas',
    view_all: 'Peržiūrėti viską',
};
